import React from 'react';
import AuthPageReader from '../AuthPageReader.jsx';

const FlexOfficeSignUpReader = (props) => <AuthPageReader {...props} domainType="FLEX_OFFICE" pageKey="signUp" />;

export default FlexOfficeSignUpReader;
